import styled, { createGlobalStyle } from 'styled-components';

import { rem } from 'approot/shared/style';
import { LANDSCAPE, Orientation } from '../activity-builder.apollo';
import { grey1 } from 'approot/shared/styles/colours.style';
import {
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  ACTIVITY_BUILDER_A4_SHORT_SIDE,
  ACTIVITY_BUILDER_HEADER_HEIGHT,
  ACTIVITY_BUILDER_FOOTER_HEIGHT,
} from '../activity-builder.constants';
import { ActivityBuilderSlideContent } from '../activity-builder-slide.style';

export const A4 = styled.div<A4PageProps>`
  background-color: ${grey1};

  @page {
    margin: 0;
    size: ${({ $orientation }) =>
      $orientation === LANDSCAPE ? 'A4 landscape' : 'A4 portrait'};
  }
`;

type A4PageProps = {
  $orientation: Orientation;
};

export const A4Page = styled.div<A4PageProps>`
  width: ${({ $orientation }) =>
    $orientation === LANDSCAPE
      ? rem(ACTIVITY_BUILDER_A4_LONG_SIDE)
      : rem(ACTIVITY_BUILDER_A4_SHORT_SIDE)};
  height: ${({ $orientation }) =>
    $orientation === LANDSCAPE
      ? rem(ACTIVITY_BUILDER_A4_SHORT_SIDE)
      : rem(ACTIVITY_BUILDER_A4_LONG_SIDE)};
  overflow: hidden;
`;

export const A4Slides = styled.div`
  height: 100%;
`;

type A4SlideProps = {
  $twoPerPage: boolean;
  $orientation: Orientation;
};

export const A4Slide = styled.div<A4SlideProps>`
  height: ${({ $twoPerPage, $orientation }) =>
    $twoPerPage
      ? `${
          ($orientation === LANDSCAPE
            ? ACTIVITY_BUILDER_A4_SHORT_SIDE
            : ACTIVITY_BUILDER_A4_LONG_SIDE) / 2
        }px`
      : `${
          $orientation === LANDSCAPE
            ? ACTIVITY_BUILDER_A4_SHORT_SIDE
            : ACTIVITY_BUILDER_A4_LONG_SIDE
        }px`};
  overflow: hidden;

  ${ActivityBuilderSlideContent} {
    height: calc(
      100% -
        ${rem(ACTIVITY_BUILDER_HEADER_HEIGHT + ACTIVITY_BUILDER_FOOTER_HEIGHT)}
    );
    overflow: hidden;
  }
`;

export const A4GlobalStyles = createGlobalStyle<A4PageProps>`
  @page {
    margin: 0;
    size: ${({ $orientation }) =>
      $orientation === LANDSCAPE ? 'A4 landscape' : 'A4 portrait'};
  }
`;
